// import $ from 'jquery';

(function() {
    const platforms = {
        ios: /(ipad|iphone|ipod)/.test(navigator.userAgent.toLowerCase()),
        android: /android/i.test(navigator.userAgent.toLowerCase()),
    };
    const html = $('html');

    Object.keys(platforms)
        .forEach((platform) => {
            platforms[platform] && html.addClass(platform);
        });
})();



// WEBPACK FOOTER //
// ./client/src/site__fus078/device-detection.js